import { Alert } from "antd";
import { mensajes_error } from "../../../data/data";

const ErrorMessage = ({ errorName, type = "warning" }) => {
    return (
        <Alert type={type} message={`${mensajes_error[errorName]}`} showIcon />
    );
};

export default ErrorMessage;
